<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { Plus, Minus, Maximize2, Link, Link2Off, Link2 } from 'lucide-vue-next'

interface Props {
  connectionMode: 'all' | 'active' | 'none'
}

defineProps<Props>()

const emit = defineEmits<{
  zoomIn: []
  zoomOut: []
  fitView: []
  cycleConnectionMode: []
}>()

const connectionModeIcon = {
  'all': Link,
  'active': Link2,
  'none': Link2Off
}

const connectionModeTitle = {
  'all': 'Showing all connections',
  'active': 'Showing active path only',
  'none': 'Connections hidden'
}
</script>

<template>
  <div class="absolute bottom-4 left-4 flex flex-col gap-2 z-10">
    <Button
      variant="outline"
      size="icon"
      @click="emit('zoomIn')"
      title="Zoom In"
      class="bg-background shadow-lg"
    >
      <Plus class="h-4 w-4" />
    </Button>
    <Button
      variant="outline"
      size="icon"
      @click="emit('zoomOut')"
      title="Zoom Out"
      class="bg-background shadow-lg"
    >
      <Minus class="h-4 w-4" />
    </Button>
    <Button
      variant="outline"
      size="icon"
      @click="emit('fitView')"
      title="Fit View"
      class="bg-background shadow-lg"
    >
      <Maximize2 class="h-4 w-4" />
    </Button>
    <Button
      variant="outline"
      size="icon"
      @click="emit('cycleConnectionMode')"
      :title="connectionModeTitle[connectionMode]"
      class="bg-background shadow-lg"
    >
      <component :is="connectionModeIcon[connectionMode]" class="h-4 w-4" />
    </Button>
  </div>
</template>
